import { create } from 'zustand'

interface Product {
  id: number | string
  name: string
  price: string
  salePrice?: string
  image: string
  collection?: string
}

interface CartItem extends Product {
  quantity: number
}

interface StoreState {
  // Cart State
  cart: CartItem[]
  isCartOpen: boolean
  addToCart: (product: Product) => void
  removeFromCart: (productId: number | string) => void
  updateQuantity: (productId: number | string, delta: number) => void
  toggleCart: (open?: boolean) => void

  // Quick View State
  quickViewProduct: Product | null
  openQuickView: (product: Product) => void
  closeQuickView: () => void
}

export const useStore = create<StoreState>((set) => ({
  cart: [],
  isCartOpen: false,
  quickViewProduct: null,

  addToCart: (product) =>
    set((state) => {
      const existingIndex = state.cart.findIndex(
        (item) => item.id === product.id,
      )
      if (existingIndex > -1) {
        const newCart = [...state.cart]
        newCart[existingIndex].quantity += 1
        return { cart: newCart, isCartOpen: true }
      }
      return {
        cart: [...state.cart, { ...product, quantity: 1 }],
        isCartOpen: true,
      }
    }),

  removeFromCart: (productId) =>
    set((state) => ({
      cart: state.cart.filter((item) => item.id !== productId),
    })),

  updateQuantity: (productId, delta) =>
    set((state) => ({
      cart: state.cart.map((item) =>
        item.id === productId
          ? { ...item, quantity: Math.max(1, item.quantity + delta) }
          : item,
      ),
    })),

  toggleCart: (open) =>
    set((state) => ({
      isCartOpen: open !== undefined ? open : !state.isCartOpen,
    })),

  openQuickView: (product) => set({ quickViewProduct: product }),
  closeQuickView: () => set({ quickViewProduct: null }),
}))
